import { ExtractionDetailsAccountSummary } from '../model/extractionDetailsAccountSummary';
import { WhitePaperReportCellChangesSummary } from '../model/whitePaperReportCellChangesSummary';
import { WhitePaperReportChanges } from '../model/whitePaperReportChanges';
import { WhitePaperReportChangesRowChanges } from '../model/whitePaperReportChangesRowChanges';

export function getChangeTrackingData(
    rowNumber: string,
    columnId: number,
    changesTrackingData: WhitePaperReportChanges | null,
    extractionDetailsAccountSummary: ExtractionDetailsAccountSummary[]
): WhitePaperReportChanges | undefined {
    //dont care about the internals of drilldown changes in current story. so setting it to empty
    const accountSummaries: WhitePaperReportCellChangesSummary[] = []; //use extractionDetailsAccountSummary
    const newTrackingData = Object.assign({}, changesTrackingData ?? {});
    if (!newTrackingData.rowChanges) {
        const changes: { [key: string]: WhitePaperReportCellChangesSummary[] } = getChangesForColumn(columnId, accountSummaries);
        const rowChanges: WhitePaperReportChangesRowChanges = {};
        rowChanges[rowNumber] = changes;
        newTrackingData.rowChanges = rowChanges;
    } else if (!newTrackingData.rowChanges![rowNumber!]) {
        const changes = getChangesForColumn(columnId, accountSummaries);
        newTrackingData.rowChanges![rowNumber!] = changes;
    } else {
        newTrackingData.rowChanges![rowNumber!][columnId!] = accountSummaries;
    }
    return newTrackingData;
}
function getChangesForColumn(columnId: number, accountSummaries: WhitePaperReportCellChangesSummary[]) {
    const changes: { [key: string]: WhitePaperReportCellChangesSummary[] } = {};
    changes[columnId] = accountSummaries;
    return changes;
}
